/**
 * @class BackgroundLayer
 * @constructor
 * @extends WebGLLayer
 */
function BackgroundLayer(name){
	WebGLLayer.call(this, name);

	// Default color
	this.colors = [{
		index: 50,
		brightness: 0,
		contrast: 7,
		r: 255,
		g: 43,
		b: 47
	}];
}

//Inheritance
BackgroundLayer.prototype = Object.create(WebGLLayer.prototype);
BackgroundLayer.prototype.constructor = BackgroundLayer;

/** @type Array.<Object> */
BackgroundLayer.prototype.colors = null;

/**
 *
 * @param {Number} progressX
 * @param {Number} progressY
 * @param {Number} canvasWidth
 * @param {Number} canvasHeight
 * @return {Array.<Number>}
 * @see http://www.dfstudios.co.uk/?page_id=423
 */
BackgroundLayer.prototype.getRectCoords = function getRectCoords(progressX, progressY, canvasWidth, canvasHeight) {
	return [
		0, 0,
		canvasWidth, 0,
		0, canvasHeight,
		0, canvasHeight,
		canvasWidth, 0,
		canvasWidth, canvasHeight
	];
};

/**
 *
 * @param {Number} progressX
 * @param {Number} progressY
 * @returns {Array.<Number>}
 */
BackgroundLayer.prototype.getTexCoords = function getTexCoords(progressX, progressY) {
	return [
		0.0, 0.0,
		1.0, 0.0,
		0.0, 1.0,
		0.0, 1.0,
		1.0, 0.0,
		1.0, 1.0
	];
};

/**
 *
 * @param {Number} progressX
 * @param {Number} progressY
 * @return {{r:Number, b:Number, b:Number, contrast:Number, brightness:Number}}
 */
BackgroundLayer.prototype.getColor = function getColor(progressX, progressY) {
	var prevColor;
	var nextColor;
	var prevFactor;
	var nextFactor;

	// Before the first color
	if(this.colors[0].index >= progressX) {
		return this.colors[0];
	}
	// After the last color
	if(this.colors[this.colors.length - 1].index <= progressX) {
		return this.colors[this.colors.length - 1];
	}

	// Between colors
	for(var colorIndex = 0, numColors = this.colors.length; colorIndex < numColors; colorIndex++){
		if(this.colors[colorIndex].index <= progressX && this.colors[colorIndex + 1].index >= progressX) {
			prevColor = this.colors[colorIndex];
			nextColor = this.colors[colorIndex + 1];
			prevFactor = (progressX - prevColor.index) / (nextColor.index - prevColor.index);
			nextFactor = (nextColor.index - progressX) / (nextColor.index - prevColor.index);
			return {
				r: nextFactor * prevColor.r + prevFactor * nextColor.r,
				g: nextFactor * prevColor.g + prevFactor * nextColor.g,
				b: nextFactor * prevColor.b + prevFactor * nextColor.b,
				contrast: (nextFactor * prevColor.contrast + prevFactor * nextColor.contrast),
				brightness: (nextFactor * prevColor.brightness + prevFactor * nextColor.brightness)
			};
		}
	}
};

/**
 *
 * @param progressX
 * @param progressY
 * @returns {WebGLTexture}
 */
BackgroundLayer.prototype.getTexture = function getTexture(progressX, progressY){
	return this.textures[0];
};